module.exports = __webpack_public_path__ + "img/home_banner_2.4dad3fda.png";